import type React from 'react';
import { Typography } from '@heroui/react';
import { asHeading2 } from './productDetailTypography';

type ProductDetailSectionHeadingProps = {
    children: React.ReactNode;
};

/**
 * A section's heading on the details page (Options, Variants): an h2 under
 * the product's name, at the small body size.
 */
export const ProductDetailSectionHeading: React.FC<
    ProductDetailSectionHeadingProps
> = ({ children }) => (
    <Typography render={asHeading2} type="body-sm" weight="semibold">
        {children}
    </Typography>
);
